"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordToggle = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _jsxRuntime = require("react/jsx-runtime");
const iconStyle = {
  fontSize: '32px'
};
const StyledIconButton = (0, _mui.styled)(_components.IconButton)(({
  theme
}) => ({
  padding: theme.spacing(0)
}));
const PasswordToggle = props => {
  const {
    isShowPassword,
    tabIndex,
    setPasswordVisible
  } = props;
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const handleClick = () => setPasswordVisible(!isShowPassword);
  const icon = isShowPassword ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.VisibilityOff, {
    sx: iconStyle,
    ...getTestIdProps('icon-visibilityOff')
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Visibility, {
    sx: iconStyle,
    ...getTestIdProps('icon-visibilityOn')
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.InputAdornment, {
    position: "end",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIconButton, {
      variant: "text",
      color: "default",
      tabIndex: tabIndex,
      onClick: handleClick,
      children: icon
    })
  });
};
exports.PasswordToggle = PasswordToggle;
